export default __webpack_public_path__ + "static/media/6.f33e0194.JPG";